export const layoutResources = {
  'layout.header.accountDropdownTitle': '帐号设定',
  'layout.notifications.clearNotifications': '清除确认的通知',
  'layout.footer.copyright': '版权 Shipium',
};

export type LayoutResourceKey =
  | 'layout.header.accountDropdownTitle'
  | 'layout.notifications.clearNotifications'
  | 'layout.footer.copyright';
